import createAction from 'redux-actions/es/createAction';

export const setupMfaRequiredRequest = createAction('SETUP_MFA_REQUIRED_REQUEST');
export const setupMfaRequiredSuccess = createAction('SETUP_MFA_REQUIRED_SUCCESS');
export const setupMfaRequiredFail = createAction('SETUP_MFA_REQUIRED_FAIL');
